import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Cake, Loader2 } from "lucide-react";

export default function Login() {
  const { login, formatApiError } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username.trim(), password);
      toast.success("Welcome back!");
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FFF8DC] px-5">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="flex flex-col items-center mb-8">
          <div className="w-20 h-20 rounded-full bg-[#8B4513] flex items-center justify-center mb-4 shadow-lg">
            <Cake className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-[#8B4513]">Divine Cakery</h1>
          <p className="text-sm text-[#666] mt-1">Admin Panel</p>
        </div>

        <div className="bg-white rounded-2xl p-6 shadow-md">
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-sm font-semibold text-[#333] mb-1.5">Username</label>
              <input
                data-testid="login-username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                className="w-full px-4 py-3 rounded-xl bg-[#FFF8DC] border border-[#e6dcc0] text-[#333] focus:outline-none focus:border-[#8B4513] transition"
                placeholder="Enter username"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-[#333] mb-1.5">Password</label>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                className="w-full px-4 py-3 rounded-xl bg-[#FFF8DC] border border-[#e6dcc0] text-[#333] focus:outline-none focus:border-[#8B4513] transition"
                placeholder="Enter password"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-[#8B4513] hover:bg-[#703710] text-white font-bold transition-colors disabled:opacity-60"
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin" />}
              Login
            </button>
          </form>
        </div>
        <p className="text-xs text-[#999] mt-5 text-center">Staff access only · Divine Cakery Management</p>
      </div>
    </div>
  );
}
